module.exports = __webpack_public_path__ + "img/no-pic.c9439792.png";